export const en = {
    'active-banners': 'Active ads',
    'active-campaigns': 'Active campaigns',
    'active-cpc-campaigns': 'Active pay-per-click campaigns',
    'active-cpm-campaigns': 'Active pay-per-impression campaigns',
    'active-groups': 'Active ad groups',
    'all-active-groups': 'Active ad groups',
    'all-archived-groups': 'Archived ad groups',
    'all-banners': 'All ads',
    'all-campaigns': 'All campaigns',
    'all-cpc-campaigns': 'Pay-per-click campaigns',
    'all-cpm-campaigns': 'Pay-per-impression campaigns',
    'all-groups': 'All ad groups',
    'all-phrases': 'All keywords',
    'all-targetings': 'All impression criteria',
    'archive-banners': 'Archived ads',
    'archive-campaigns': 'Archived campaigns',
    'archive-cpc-campaigns': 'Archived pay-per-click campaigns',
    'archive-cpm-campaigns': 'Archived pay-per-impression campaigns',
    'archive-groups': 'Archived ad groups',
    'archived-status': 'Archive',
    banners: 'Ads',
    'cpc-campaigns': 'Per click',
    'cpm-campaigns': 'Per impression',
    'draft-status': 'Draft',
    'minus-phrase-binding-error-grid-alert-message':
        'Unable to link sets of negative keywords to these ad groups. The maximum number of sets might be linked already',
    'minus-phrase-unbinding-error-grid-alert-message':
        'Unable to unlink sets of negative keywords from these ad groups',
    'pause-status': 'Paused',
    phrases: 'Keywords',
    'regions-transform-error-grid-alert-message': 'Unable to change display regions in these ad groups',
    'run-ok-status': 'Active',
    'run-warn-status': 'Active with restrictions',
    'stop-status': 'Stopped',
    targetings: 'Targetings'
};
